import SearchSimple from '../../../../components/SearchSimples/SearchSimple';
import MenuApp from './Functionality/MenuApp';
import { permissionObj } from '../../../../Helpers/permission';
import DeleteModal from './../../../Modals/DeleteModal';
import { SUB_VIEW_MODEL } from '../Model/Models';
import ButtonAction from './../../../../components/buttons/ButtonAction';
import Calendar from './SubComponents/Calendar';
import MenuAccordion from './SubComponents/MenuAccordion';
import MealForecast from "./SubComponents/MealForecast";

/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 * @param setBodyForExport - Sets the data body for export functionality (required)
 * @param search - The current search input value (required)
 * @param setSearch - Updates the search input value (required)
 * @param {boolean} modified - Flag to track data modifications.
 * @param {Function} setModified - Setter used to update the `modified` flag and trigger data reloads (required).
 * @param setSearchElement - Updates the state of the advanced search value (optional/required depending on the view)
 * @param searchElement - Current value for the advanced search (string or structured criteria, required)
 * @param subView - Current active view (Menus, Calendar, or MealForecast, required)
 * @param setSubView - Updates the current active sub-view (required)
 * @param option
 * @param setOption
 * @param setModuleId
 */

const Menu = ({
    setBodyForExport,
    search,
    setSearch,
    modified,
    setModified,
    setSearchElement,
    searchElement,
    subView,
    setSubView,
    option,
    setOption,
    setModuleId
}) => {
    const {
        t,
        DEV,
        permission,
        searchId,
        rowsPerPage,
        setSimpleSearch,
        handleCheckboxChange,
        pagination,
        deleteModalShow,
        handleDeleteSelected,
        handleDeleteModalClose,
        selectForDelete,
        handleShowMenu,
        handleShowCalendar,
        handleShowMealForecast,
        resultsToShow,
        setResultsToShow,
        columns,
        renderOptionsMenu,
        navigate,
        handleDeleteAll,
        searchMealForecast,
        isFutureDate
    } = MenuApp({
        setBodyForExport,
        modified,
        setModified,
        searchElement,
        setSearchElement,
        subView,
        setSubView,
        option,
        setOption,
        setModuleId
    });
    return (
        <>
            <div className='d-flex gap-2'>
                {(DEV || permission?.includes(permissionObj?.WEB_FOODIE_MENU_READ)) &&
                    <ButtonAction
                        id='btn_m_menu'
                        name='menu'
                        className={
                            subView === SUB_VIEW_MODEL.MENUS.MENUS
                                ? 'btn-outlined-secondary-600-100'
                                : 'btn-outlined-secondary-600-00'
                        }
                        disabled={false}
                        splitName={false}
                        onClick={handleShowMenu}
                    />
                }
                {(DEV || permission?.includes(permissionObj?.WEB_FOODIE_MENU_READ)) &&
                    <ButtonAction
                        id='btn_m_calendar'
                        name='calendar'
                        className={
                            subView === SUB_VIEW_MODEL.MENUS.CALENDAR
                                ? 'btn-outlined-secondary-600-100'
                                : 'btn-outlined-secondary-600-00'
                        }
                        disabled={false}
                        splitName={false}
                        onClick={handleShowCalendar}
                    />
                }

                {(DEV || permission?.includes(permissionObj?.WEB_FOODIE_MEAL_FORECAST_READ)) &&
                <ButtonAction
                    id='btn_m_meal_forecast'
                    name='meal_forecast'
                    className={
                        subView === SUB_VIEW_MODEL.MENUS.MEAL_FORECAST
                            ? 'btn-outlined-secondary-600-100'
                            : 'btn-outlined-secondary-600-00'
                    }
                    disabled={false}
                    splitName={false}
                    onClick={handleShowMealForecast}
                />
                }


                {(subView === SUB_VIEW_MODEL.MENUS.MENUS || subView === SUB_VIEW_MODEL.MENUS.MEAL_FORECAST) && (
                    <div className='flex-grow-1'>
                        <SearchSimple
                            id={searchId}
                            setBodyForExport={subView === SUB_VIEW_MODEL.MENUS.MEAL_FORECAST ? undefined : setBodyForExport}
                            setSearchResults={setResultsToShow}
                            searchElement={searchElement}
                            setSearchElement={setSearchElement}
                            optionTable={option}
                            rowsPerPage={rowsPerPage}
                            setSimpleSearch={setSimpleSearch}
                            search={search}
                            setSearch={setSearch}
                            contractorId={null}
                            supplierId={null}
                            callApi={(subView === SUB_VIEW_MODEL.MENUS.MEAL_FORECAST)
                                ? () => searchMealForecast(searchElement) : undefined
                            }
                            resetApi={(subView === SUB_VIEW_MODEL.MENUS.MEAL_FORECAST)
                                ? () => searchMealForecast("") : undefined
                            }
                        />
                    </div>
                )}
            </div>


            {subView === SUB_VIEW_MODEL.MENUS.MENUS && (
                <>
                    <MenuAccordion
                        t={t}
                        DEV={DEV}
                        columns={columns}
                        searchResults={resultsToShow}
                        handleCheckboxChange={handleCheckboxChange}
                        handleCheckedAll={handleDeleteAll}
                        selectedList={selectForDelete}
                        renderOptionsMenu={renderOptionsMenu}
                        searchElement={searchElement}
                    />
                    {pagination()}
                </>
            )}

            { subView === SUB_VIEW_MODEL.MENUS.CALENDAR && (
                <Calendar
                    t={t}
                    DEV={DEV}
                    permission={permission}
                    navigate={navigate}
                    isFutureDate={isFutureDate}
                />
            )}

            {subView === SUB_VIEW_MODEL.MENUS.MEAL_FORECAST && (
                <MealForecast
                    t={t} DEV={DEV}
                    results={resultsToShow}
                    setResults={setResultsToShow}
                    setBodyForExport={setBodyForExport}
                />
            )}
            {deleteModalShow && (
                <DeleteModal
                    show={deleteModalShow}
                    onHide={() => handleDeleteModalClose()}
                    onClickFn={() => {
                        handleDeleteSelected();
                    }}
                    data={selectForDelete}
                    title_modal={t('delete_menu')}
                    element_modal={t('menu')}
                    buttonCancelText={'cancel'}
                />
            )}
        </>
    );
};

export default Menu;
